import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const ReceiptDetails = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const [recordCount, setRecordCount] = useState(0);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        SaleDate: '',
        ReferenceNo: 0,
        CustomerId: '',
        PackingListId: '',
        TotalBilledQuantity: 0,
        TotalBilledAmount: 0,
        Remarks: '',
        Packinglistdeatils: '',
        PaymentType: 0,
        createdBy: userId,
        isSubmit: false,
        BalBox: 0,
        Box: 0,
        TotalBalAmt: 0,
    });


    useEffect(() => {
        fetchData('ReceiptApi', `/ReceiptData/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const invoiceData = response.response_data.PaymentAndReceipt;
                    setFormData({
                        ...invoiceData,
                        UpdatedBy: userId,
                    });
                    console.log(response);

                    const updatedInvoicedetailsSorted = response.response_data.PaymentAndReceiptSale;
                    setInvoicedeatils(updatedInvoicedetailsSorted);
                    console.log(updatedInvoicedetailsSorted);
                }
            })
            .catch((error) => {
                console.error('Error fetching Invoice Details:', error);
            });
    }, [id]);

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);

        setFormData((prevData) => ({
            ...prevData,
            PartyId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (selectedOption) {
            fetchData('ReceiptApi', `/PartyReceiptBill/${selectedOption.value}/${companyId}`, token)
                .then((response) => {
                    if (response.responseCode === '1111') {

                        const updatedInvoicedetailsSorted = response.response_data;

                        const totalSaleAmount = updatedInvoicedetailsSorted.reduce((total, invdetail) => {
                            return total + invdetail.SaleAmount;
                        }, 0);

                        // Update formData with total SaleAmount
                        setFormData((prevData) => ({
                            ...prevData,
                            TotalBalAmt: totalSaleAmount,
                        }));

                        setInvoicedeatils(updatedInvoicedetailsSorted);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching invoice details:', error);
                });
        }

    };


    useEffect(() => {
        fetchCustomerData();
    }, []);

    //FOR GET Customer  Details FROM API
    const fetchCustomerData = () => {
        fetchData('CustomerApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((customer) => ({
                    label: customer.Name +customer.addressLine1,
                    value: customer.Id,
                }));
                setCustomerOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };



    const submitData = async (e) => {
        setIsLoading(true);


        if (!formData.Amount || formData.Amount === 0) {
            setErrorMessage('Amount must be Greater than 0!');
            setIsLoading(false);
            return;
        }

        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
        }));

        const createData = {
            PaymentAndReceipt: formData,
            PaymentAndReceiptRentCollection: invoicedeatils,
        };

        updateData('ReceiptApi', `${id}`, createData, token)
            .then((response) => {
                setSuccessMessage('Receipt Updated successfully!');
                setErrorMessage('');

                history.push('/ReceiptIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);

            })
            .catch((error) => {
                console.error('Receipt Create error:', error);
                setIsLoading(false);
            });

    };

    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (name === 'Amount') {
            let newAmount = parseFloat(value);
            if (isNaN(newAmount)) {
                newAmount = 0;
            }

            // Ensure the entered amount does not exceed formData.TotalBalAmt
            const restrictedAmount = Math.min(newAmount, formData.TotalBalAmt);

            // Update formData with the restricted amount value
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : restrictedAmount,
            }));

            // Initialize remaining balance to the restricted amount
            let remainingBalance = restrictedAmount;

            // Loop through each row in invoicedeatils
            const updatedInvoicedeatils = invoicedeatils.map((invdetail) => {
                // Calculate the amount for this row (minimum of SaleAmount and remaining balance)
                const amountForThisRow = Math.min(invdetail.SaleAmount, remainingBalance);

                // Update the remaining balance
                remainingBalance -= amountForThisRow;

                // Ensure invdetail.Amount does not exceed invdetail.SaleAmount
                const updatedAmount = Math.min(amountForThisRow, invdetail.SaleAmount);

                // Calculate the balance amount for this row (ensure it's not negative)
                const balanceForThisRow = Math.max(invdetail.SaleAmount - updatedAmount, 0);

                // Return the updated row
                return {
                    ...invdetail,
                    Amount: updatedAmount,
                    BalanceAmount: balanceForThisRow,
                };
            });

            // Update invoicedeatils with the updated values
            setInvoicedeatils(updatedInvoicedeatils);
        } else if (name === 'PaymentType') {
            // Handle changes for the Payment Type radio buttons
            setFormData((prevData) => ({
                ...prevData,
                PaymentType: value,
            }));
        }
        else {
            // For other form fields, update formData directly
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    };

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");

    return (
        <Fragment>

            <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '900px', overflow: 'auto' }}>
                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.5em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                        
                        
                    `}
                </style>


                <div>

                    <div className='w-full flex' style={{ marginTop: '10px' }}>
                        <h6 className="productHead flex-grow linkcolorBlack" style={{ fontFamily: 'Times new romans', fontWeight: 'bolder' }}>RECEIPT DETAILS</h6>
                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/ReceiptIndex"
                            className="linkcolor"
                            style={{
                                marginRight: '8px',
                                background: 'linear-gradient(to right, darkred, slategray)',
                                borderRadius: '50px',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                height: '30px'
                            }}

                        >
                            BACK
                        </Button>

                       

                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}
                    <div className="w-full mb-2 flex flex-wrap"> <div className="w-full mb-2 flex flex-wrap">

                        <div className="w-full sm:w-1/5 pl-2  sm:block">
                            <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="customer">
                                Route
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.RouteName}
                                type="text"
                                name='RouteName'
                                readOnly
                            />
                        </div>

                        <div className="w-full sm:w-1/3 pl-2  sm:block">
                            <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="customer">
                                Customer
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                // value={formData.PartyName}{formData.AddressLine1}
                                value= {`${formData.PartyName} ${formData.AddressLine1}`} 
                                type="text"
                                name='CustomerName'
                                readOnly
                            />
                        </div>
                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Reference Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.ReferenceDate)}
                                type="date"
                                placeholder="Enter Reference Date"
                                name='ReferenceDate'
                                readOnly
                            />
                        </div>
                        <div className="w-full sm:w-1/5 pl-2  sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                PaymentType
                                <span className="text-red-500">*</span>
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={(formData.PaymentTypeStatus)}
                                name='ReferenceDate'
                                readOnly
                                style={{color:'darkred' , fontWeight:'bold'}}
                            />
                        </div>

                    </div>

                        <div className="w-full sm:w-1/5 pl-2 sm:block">
                            <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="customer">
                                Bank
                                <span className="text-red-500">*</span>
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={(formData.BankName)}
                                name='ReferenceDate'
                                readOnly
                            />
                        </div>



                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="Chequeno">
                                Cheque No.
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Chequeno}
                                type="text"
                                placeholder=""
                                name="Chequeno"
                                readOnly

                            />
                        </div>




                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="ChequeDate">
                                Cheque Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.ChequeDate)} // Current date as default
                                placeholder=""
                                name="ChequeDate"
                                readOnly
                            />
                        </div>


                        <div className="w-full sm:w-2/5 pl-2 hidden sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="chequeDetails">
                                Cheque Details
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.chequeDetails}
                                type="text"
                                placeholder=""
                                name="chequeDetails" 
                                readOnly

                            />
                        </div>

                        <div className="w-full mb-2 flex flex-wrap">
                            <div className="w-full sm:w-2/5 pr-2 mb-2 sm:mb-0">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="rate">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Remarks}
                                    type="text"
                                    placeholder="Enter Remarks"
                                    name='Remarks'
                                    readOnly
                                />
                            </div>

                            <div className="w-full sm:w-1/5 pr-2 mb-2 sm:mb-0">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                    Advance Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.UsedAdvanceAmt}
                                    type="text"
                                    placeholder="Enter Amount"
                                    name='UsedAdvanceAmt'
                                    autoComplete='off'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-full sm:w-1/5 pr-2 mb-2 sm:mb-0">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                    Return Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.ReturnTotalAmt}
                                    type="text"
                                    placeholder="Enter Amount"
                                    name='ReturnTotalAmt'
                                    autoComplete='off'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-full sm:w-1/5 pr-2 mb-2 sm:mb-0">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                    Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Amount}
                                    type="number"
                                    placeholder="Enter Amount"
                                    name='Amount'
                                    autoComplete='off'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                        </div>

                    </div>
                    <div style={{ marginTop: '10px' }}>
                        <div className="w-full mb-2 flex">
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th style={{ padding: '8px', textAlign: 'center' }}>Sale Bill Details</th>
                                                <th style={{ padding: '8px', textAlign: 'center', textAlign: 'right' }}>Bill Amount</th>
                                                <th style={{ padding: '8px', textAlign: 'center', textAlign: 'right' }}>Paid Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils && invoicedeatils.map((invdetail, index) => (
                                                <tr key={index}>
                                                    <td style={{ padding: '1px', fontSize: '14px', width: '40%', textAlign: 'center' }}>{invdetail.SaleDescription}</td>
                                                    <td style={{ padding: '1px', fontSize: '14px', width: '20%', textAlign: 'right' }}>
                                                        {invdetail.SaleAmount}
                                                    </td>
                                                    <td style={{ padding: '1px', fontSize: '14px', width: '20%', textAlign: 'right' }}>
                                                        {invdetail.Amount}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>


                                    </table>
                                </TableContainer>


                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </Fragment >
    );
}

export default ReceiptDetails;
